import Config from '../../config';

type UserId = {
  userId: string;
  email: string;
};

const identifyAnalytics = (userId: UserId): void => {
  if (pendo && pendo.initialize) {
    const visitor: Visitor = {
      email: userId.email,
      id: userId.userId,
      environment: Config.environment || 'unknown',
    };
    const account = {
      id: userId.email, // Use email as account ID for better readability
    };
    // Initialize Pendo with visitor and account data to prevent anonymous sessions
    pendo.initialize({ visitor, account });
  }
};

const trackEvent = (eventName: string, metadata?: Record<string, any>): void => {
  if (pendo && pendo.track) {
    pendo.track(eventName, metadata);
  }
};

export { identifyAnalytics, trackEvent };
